import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaTimes, FaSpinner, FaMagic } from "react-icons/fa";
import axios from "axios";
import MarkdownIt from "markdown-it";

function AIPromptModal({ setShowPromptInput, quill }) {
  const [promptInput, setPromptInput] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);

  const md = new MarkdownIt();

  const handleGenerateText = async () => {
    if (!quill || !promptInput.trim()) return;

    setIsGenerating(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/gemini/generate-text`,
        { prompt: promptInput },
        {
          headers: {
            "x-auth-token": localStorage.getItem("token"), // Assuming you store the token in localStorage
          },
        }
      );

      const markdownText = response.data.text;
      const htmlContent = md.render(markdownText);

      const range = quill.getSelection(true);
      if (range) {
        quill.clipboard.dangerouslyPasteHTML(range.index, htmlContent);
      } else {
        quill.clipboard.dangerouslyPasteHTML(quill.getLength(), htmlContent);
      }

      setPromptInput("");
      setShowPromptInput(false);
    } catch (error) {
      console.error("Error generating text:", error);
      // Handle error (e.g., show a toast notification)
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    >
      <motion.div
        initial={{ scale: 0.9, y: 50 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.9, y: 50 }}
        className="bg-white p-6 rounded-lg shadow-2xl w-full max-w-xl"
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-gray-800">
            intelleX AI Assistant
          </h3>
          <button
            onClick={() => setShowPromptInput(false)}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>
        <textarea
          value={promptInput}
          onChange={(e) => setPromptInput(e.target.value)}
          placeholder="What should intelleX AI write for you today?"
          className="w-full h-32 p-3 border border-gray-300 rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300 text-gray-700 text-base resize-none"
        />
        <div className="flex justify-end">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleGenerateText}
            disabled={isGenerating}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:ring-opacity-50 font-semibold text-sm shadow-lg"
          >
            {isGenerating ? (
              <span className="flex items-center">
                <FaSpinner className="animate-spin mr-2" />
                Generating...
              </span>
            ) : (
              <span className="flex items-center">
                <FaMagic className="mr-2" />
                Generate
              </span>
            )}
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
}

export default AIPromptModal;